import { createSlice } from "@reduxjs/toolkit";
import { getUserFromStorage } from "../../Utils/helpers";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: getUserFromStorage(),
  },
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    deleteUser: (state, action) => {
      state.user = null;
    },
  },
});

export const { setUser, deleteUser } = authSlice.actions;
export default authSlice.reducer;
